import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    type: { type: String, default: "line" },
    data: Object
  }

  connect() {
    this.renderChart()
    this.boundBeforeCache = this.beforeCache.bind(this)
    this.boundResize = this.handleResize.bind(this)
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)
    window.addEventListener("resize", this.boundResize)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
    window.removeEventListener("resize", this.boundResize)
    this.destroyChart()
  }

  handleResize() {
    if (this.chart) {
      this.chart.resize()
    }
  }

  beforeCache() {
    this.destroyChart()
  }

  dataValueChanged() {
    this.destroyChart()
    this.renderChart()
  }

  destroyChart() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  renderChart() {
    if (!this.hasCanvasTarget) return

    const existingChart = Chart.getChart(this.canvasTarget)
    if (existingChart) {
      existingChart.destroy()
    }

    const ctx = this.canvasTarget.getContext("2d")

    // 複合グラフ（y1軸）があるかチェック
    const hasSecondAxis = this.dataValue.datasets?.some(ds => ds.yAxisID === "y1")
    // スタックバーがあるかチェック
    const hasStackedBars = this.dataValue.datasets?.some(ds => ds.stack)

    const scales = {
      x: {
        stacked: hasStackedBars
      },
      y: {
        stacked: hasStackedBars,
        position: "left"
      }
    }

    if (hasSecondAxis) {
      scales.y1 = {
        position: "right",
        grid: {
          drawOnChartArea: false
        }
      }
    }

    const isPieType = ["pie", "doughnut"].includes(this.typeValue)

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top"
        }
      }
    }

    if (!isPieType) {
      options.scales = scales
    }

    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: this.dataValue,
      options: options
    })
  }
}
